// let ENV = "DEMO";
// let ENV = "DEV";
// let ENV = "TEST";
//  let ENV = "BOLERO";
 let ENV = "BOL_PRD";
let basename = "";
let baseUrl = "";
let homepage = "";
let LOCAL_STORAGE_KEY = "";
let User_Info = "";
let loginKey = "PassLoginwZrC4^ozp0RmRz4gn^Y19!";
if (ENV === "DEMO") {
  basename = "UniConDemoUI";
  // homepage ="https://app.sflhub.com/UniConDemoUI/"
  baseUrl = "https://app.sflhub.com/UniConDemoApi/";
  LOCAL_STORAGE_KEY = "uniconDemo";
  User_Info = "UserDemo";
} else if (ENV === "DEV") {
  basename = "UniConDevUI";
  // homepage="https://app.sflhub.com/UniConDevUI/"
  baseUrl = "https://app.sflhub.com/UniConDevAPI/";
  LOCAL_STORAGE_KEY = "uniconDev";
  User_Info = "UserDev";
} else if (ENV === "TEST") {
  basename = "UniConTestUI";
  // homepage="https://app.sflhub.com/UniConTestUI/"
  baseUrl = "https://app.sflhub.com/UniConTestAPI/";
  LOCAL_STORAGE_KEY = "uniconTest";
  User_Info = "UserTest";
} else if (ENV === "BOLERO") {
  basename = "BolloreUI";
  // homepage="https://dev.sflhub.com/BolloreUI/"
  baseUrl = "https://dev.sflhub.com/BolloreApi/";
  LOCAL_STORAGE_KEY = "BolloreUI";
  User_Info = "UserBolero";
} else if (ENV === "BOL_PRD") {
  basename = "";
  // homepage="https://bollore.sflhub.com/"
  baseUrl = "https://bollore.sflhub.com/BolloreApi";
  LOCAL_STORAGE_KEY = "BolloreUIPRD";
  User_Info = "UserBoleroPrd";
}
export { basename, baseUrl, LOCAL_STORAGE_KEY, loginKey, User_Info };
